import StatCard from '@/pages/agentDashboard/components/StatsCard/StatsCard';
import PhenomChip from '@/components/PhenomChip/PhenomChip';
import TetherIcon from '@/features/rewards/Tabs/RedeemTab/components/TetherIcon/TetherIcon';
import React from 'react';
import useGetAgentRakeStats from '@/services/rake/queries/useGetAgentRakeStats';
import useIsMobileView from '@/hooks/useIsMobileView';
import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner';
import { formatValue } from '@/pages/agentDashboard/utils/utils';

const INFO_TOOLTIP = 'From referrals only and not from personal play';

const AgentStatsSection = () => {
  const { data: rakeStatsData, isLoading: isLoadingRakeStats } = useGetAgentRakeStats();
  const isMobileView = useIsMobileView();

  if (isMobileView) {
    return (
      <div className="scrollbar-phenom flex flex-col items-center justify-between overflow-x-auto rounded-2xl bg-phenom-background-gradient-purple-fade p-2">
        <span className="text-xs font-bold text-ph-white-30">Total Revenue Share</span>
        <div className="flex items-center gap-1">
          <TetherIcon width="20" height="20" />
          {isLoadingRakeStats ? (
            <LoadingSpinner />
          ) : (
            <span className="text-xl font-extrabold text-white">
              {rakeStatsData?.data.totalRevenueShare !== undefined
                ? formatValue(rakeStatsData?.data.totalRevenueShare || 0)
                : '-'}
            </span>
          )}
        </div>
      </div>
    );
  }

  return (
    <section className="scrollbar-phenom flex items-center justify-between gap-24 overflow-x-auto rounded-2xl bg-phenom-background-gradient-purple-fade px-7 py-4">
      <div className="flex gap-14">
        <StatCard
          isLoading={isLoadingRakeStats}
          value={rakeStatsData?.data.totalTokensEarned}
          icon={<PhenomChip width="32" height="32" />}
          title="Total Tokens Earned"
          info={INFO_TOOLTIP}
        />
        <StatCard
          isLoading={isLoadingRakeStats}
          value={rakeStatsData?.data.totalRevenueShare}
          icon={<TetherIcon width="32" height="32" />}
          title="Total Revenue Share"
          info={INFO_TOOLTIP}
        />
      </div>
      <div className="flex gap-9 rounded-2xl">
        <div className="ml-9 border-r-[1px] border-ph-white-10 pr-9">
          <StatCard
            isLoading={isLoadingRakeStats}
            value={rakeStatsData?.data.dayRevenue.current}
            icon={<TetherIcon useGreyIcon width="32" height="32" />}
            title="Last 24 Hours"
            change={rakeStatsData?.data.dayRevenue.trend}
          />
        </div>
        <div className="border-r-[1px] border-ph-white-10 pr-9">
          <StatCard
            isLoading={isLoadingRakeStats}
            value={rakeStatsData?.data.weekRevenue.current}
            icon={<TetherIcon useGreyIcon width="32" height="32" />}
            title="Last 7 Days"
            change={rakeStatsData?.data.weekRevenue.trend}
          />
        </div>
        <StatCard
          isLoading={isLoadingRakeStats}
          value={rakeStatsData?.data.yearRevenue.current}
          icon={<TetherIcon useGreyIcon width="32" height="32" />}
          title="Last 365 Days"
          change={rakeStatsData?.data.yearRevenue.trend}
        />
      </div>
    </section>
  );
};

export default AgentStatsSection;
